/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface ISetDataSettingsModalControllerScope extends IBaseModalControllerScope {
        workflowBlock: models.SetDataWorkflowBlock;
        isReadonly: boolean;
        processConfigId: string;

        addSetDataOperation(): void;
        deleteSetDataOperation(dto: Wars.Domain.Model.Dtos.Workflow.SetDataOperationDto): void;
        save(): void;
        cancel(): void;
    }

    export class SetDataSettingsModalController extends BaseModalController {
        scope: ISetDataSettingsModalControllerScope;

        constructor(
            $scope: ISetDataSettingsModalControllerScope,
            workflowBlock: models.SetDataWorkflowBlock,
            processConfigId: string,
            private workflowService: services.WorkflowService,
            private treeService: services.TreeService,
            private treeItemService: services.TreeItemService,
            isReadonly: boolean,
            close: any)
        {
            super($scope, close);
            this.scope = $scope;
            this.scope.workflowBlock = workflowBlock;
            this.scope.isReadonly = isReadonly;
            this.scope.processConfigId = processConfigId;

            this.scope.addSetDataOperation = () => this.addSetDataOperation();
            this.scope.deleteSetDataOperation = (dto: Wars.Domain.Model.Dtos.Workflow.SetDataOperationDto) => this.deleteSetDataOperation(dto);
            this.scope.save = () => this.save();
            this.scope.cancel = () => this.cancel();
        }

        private addSetDataOperation(): void {
            var newSetDataOperation = this.workflowService.createNewDataOperation(this.scope.workflowBlock.setDataDto);
        }

        private deleteSetDataOperation(dto: Wars.Domain.Model.Dtos.Workflow.SetDataOperationDto): void {
            this.scope.workflowBlock.setDataDto.mySetDataOperations.remove(dto);
        }

        private save(): void {
            // Save all tree item changes that are handled via breeze before trying to save workflow block changes which are all non-breeze
            this.treeItemService.saveAllChanges( () => {
                this.dismissModal(true);
            });
        }

        private cancel(): void {
            this.treeItemService.rejectChanges();
            this.dismissModal(false);
        }
    }
}

warsApp.registerController('SetDataSettingsModalController',
    ['$scope', 'workflowBlock', 'processConfigId', "workflowService", "treeService", "treeItemService", 'isReadonly', 'close']);